<template>
    <div class="wrapper" v-show="show">
        <div class="toast">
            <div class="content">
                {{message}}
            </div>
            <div class="footer" @click="ok">
                知道了
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Toast',
        props: {
            message: {
                type: String
            }
        },
        data() {
            return {
                show: false
            }
        },
        methods: {
            ok() {
                // this.$emit()
                this.show = false;
            }
        }
    }
</script>

<style scoped>
.wrapper {
    position: fixed;
    top: 0;
    z-index: 9;
    bottom: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.8);
}
.toast {
    position: fixed;
    left: 50%;
    top: 40%;
    width: 60%;
    transform: translateX(-50%);
    font-size: 0.3rem;
    background: #ffffff;
    text-align: center;
    border-radius: 8px;
}
.content {
    padding: 16px;
}
.footer {
    padding: 8px;
    border-top: 1px solid #eee;
    font-size: 0.3rem;
}
</style>